import { render, staticRenderFns } from "./EmailBodyNav.vue?vue&type=template&id=672945c6&"
import script from "./EmailBodyNav.vue?vue&type=script&lang=js&"
export * from "./EmailBodyNav.vue?vue&type=script&lang=js&"
import style0 from "./EmailBodyNav.vue?vue&type=style&index=0&id=672945c6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports